// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_tZIRK {
  width: 90%;
  text-align: center;
}

.title_u55f3 {
  font-size: clamp(20px, 5vw, 40px) !important; 
  color: var(--_10a37f-background);
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-weight: 300;
}


.subtitle_dWlnO {
  font-size: clamp(15px, 3vw, 21px) !important;
  color: #222222 !important;
  font-weight: 600;
  margin: 0;
}

.sliderWrapper_OR7u7 {
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: 40px auto;
}

.slider_L9Pwq {
  appearance: none;
  width: 100%;
  height: 10px;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  position: relative; 
  z-index: 2; 
  padding: 0px;
}

.slider_L9Pwq::-webkit-slider-thumb {
  appearance: none;
  width: 30px;
  height: 30px;
  background: var(--white-color);
  border-radius: 50%;
  background-size: cover;
  cursor: pointer;
  box-shadow: 0 0 4px var(--_00000033-shadow);
  margin-right: 50px;
  box-sizing: border-box;
}

.slider_L9Pwq::-moz-range-thumb {
  width: 30px;
  height: 30px;
  background: var(--white-color);
  border-radius: 50%;
  background-size: cover;
  cursor: pointer;
  box-sizing: border-box;
}

.labels_avocI {
  position: relative;
  margin-top: 10px;
  height: 40px;
}

.mark_CshZB {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  bottom: 15px;
  transform: translateX(-50%);
}


.label_KyYkz {
  color: #555;
  white-space: nowrap;
  font-size: 8px;
  margin-top: -20px;
}

.infoContainer_gsSZX {
  margin: 20px 0;
  h3,
  p {
    margin: 0;
  }
  p {
    overflow: hidden;
    color: var(--_10a37f-background);
    text-align: center;
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%;
  }
  h3 {
    color: var(--_10a37f-background);
    font-family: Inter;
    font-size: 36px;
    font-style: normal;
    font-weight: 800;
    line-height: 130%; 
    span {
      color: var(--_10a37f-background);
      font-family: Inter;
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; 
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/BillingSlider/BillingSlider.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;;AAGA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;;;AAGA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd;;IAEE,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB;MACE,gCAAgC;MAChC,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF","sourcesContent":[".container {\n  width: 90%;\n  text-align: center;\n}\n\n.title {\n  font-size: clamp(20px, 5vw, 40px) !important; \n  color: var(--_10a37f-background);\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  font-weight: 300;\n}\n\n\n.subtitle {\n  font-size: clamp(15px, 3vw, 21px) !important;\n  color: #222222 !important;\n  font-weight: 600;\n  margin: 0;\n}\n\n.sliderWrapper {\n  position: relative;\n  width: 100%;\n  max-width: 800px;\n  margin: 40px auto;\n}\n\n.slider {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 10px;\n  border-radius: 5px;\n  outline: none;\n  cursor: pointer;\n  position: relative; \n  z-index: 2; \n  padding: 0px;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 30px;\n  height: 30px;\n  background: var(--white-color);\n  border-radius: 50%;\n  background-size: cover;\n  cursor: pointer;\n  box-shadow: 0 0 4px var(--_00000033-shadow);\n  margin-right: 50px;\n  box-sizing: border-box;\n}\n\n.slider::-moz-range-thumb {\n  width: 30px;\n  height: 30px;\n  background: var(--white-color);\n  border-radius: 50%;\n  background-size: cover;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.labels {\n  position: relative;\n  margin-top: 10px;\n  height: 40px;\n}\n\n.mark {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  bottom: 15px;\n  transform: translateX(-50%);\n}\n\n\n.label {\n  color: #555;\n  white-space: nowrap;\n  font-size: 8px;\n  margin-top: -20px;\n}\n\n.infoContainer {\n  margin: 20px 0;\n  h3,\n  p {\n    margin: 0;\n  }\n  p {\n    overflow: hidden;\n    color: var(--_10a37f-background);\n    text-align: center;\n    text-overflow: ellipsis;\n    font-family: Inter;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 160%;\n  }\n  h3 {\n    color: var(--_10a37f-background);\n    font-family: Inter;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 130%; \n    span {\n      color: var(--_10a37f-background);\n      font-family: Inter;\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 140%; \n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_tZIRK`,
	"title": `title_u55f3`,
	"subtitle": `subtitle_dWlnO`,
	"sliderWrapper": `sliderWrapper_OR7u7`,
	"slider": `slider_L9Pwq`,
	"labels": `labels_avocI`,
	"mark": `mark_CshZB`,
	"label": `label_KyYkz`,
	"infoContainer": `infoContainer_gsSZX`
};
export default ___CSS_LOADER_EXPORT___;
